import type { Bundle } from "@/types";
import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export const getBundles = async (): Promise<ServiceResponse<Bundle[]>> => {
  const response = await privateAPI.get<ServiceResponse<Bundle[]>>("/bundles");
  return response.data;
};

export const getBundle = async (bundleId?: Bundle["id"]): Promise<Bundle> => {
  const response = await privateAPI.get<ServiceResponse<Bundle>>(
    `/bundles/${bundleId}`,
    {
      params: {
        include: "materials,meditations",
      },
    },
  );
  return response.data.data;
};

export const addBundle = async (bundle: Partial<Bundle>): Promise<Bundle> => {
  const response = await privateAPI.post<ServiceResponse<Bundle>>(
    `/bundles`,
    bundle,
  );
  return response.data.data;
};

export const updateBundle = async ({
  bundleId,
  bundle,
}: {
  bundleId: Bundle["id"];
  bundle: Partial<Bundle>;
}): Promise<Bundle> => {
  const response = await privateAPI.put<ServiceResponse<Bundle>>(
    `/bundles/${bundleId}`,
    bundle,
  );
  return response.data.data;
};

export const deleteBundle = async (bundleId: Bundle["id"]): Promise<void> => {
  await privateAPI.delete(`/bundles/${bundleId}`);
};
